export default "__VITE_ASSET__BabPF4IP__"